import Http from '@/api/http.js'

export default {

  index(filter) {
    return Http.get(`/default_client_payments`, {params: filter})
  },
  create(default_client_payment){
    return Http.post(`/default_client_payments`, {
      default_client_payment
    })
  },
  update(default_client_payment){
    return Http.put(`/default_client_payments/${default_client_payment.id}`, {
      default_client_payment: {...default_client_payment},
    });
  },
  delete(id){
    return Http.delete(`/default_client_payments/${id}`);
  },
}
